export const testimonials = [
  {
    id: 1,
    name: 'Selin K.',
    initials: 'SK',
    comment: 'Ayşegül Hanım ile çalışmak hayatımı gerçekten değiştirdi. Eşimle yıllardır çözümleyemediğimiz sorunlarımızı birkaç seansta ele alabilir hale geldik. Sabırlı, anlayışlı ve son derece profesyonel bir danışman.',
    rating: 5,
    service: 'Çift Danışmanlığı',
  },
  {
    id: 2,
    name: 'Mehmet ve Aylin T.',
    initials: 'MT',
    comment: 'İlk seans öncesi çok tedirgin ve şüpheciydik. Ama Ayşegül Hanım bizi öyle bir karşıladı ki, tüm o endişeler bir anda eridi. Artık birbirimizi çok daha iyi anlıyoruz.',
    rating: 5,
    service: 'Aile Terapisi',
  },
  {
    id: 3,
    name: 'Zeynep B.',
    initials: 'ZB',
    comment: 'Bireysel danışmanlık sürecimde kendimi gerçekten güvende hissettim. Ayşegül Hanım\'ın yaklaşımı son derece empatik; yargılamadan, sadece dinleyerek ve rehberlik ederek ilerliyor.',
    rating: 5,
    service: 'Bireysel Danışmanlık',
  },
  {
    id: 4,
    name: 'Caner Ö.',
    initials: 'CÖ',
    comment: 'Oğlumun ergenlik dönemindeki zorluklarını aşmasında büyük yardımı oldu. Çocuğuma nasıl yaklaşacağımı öğretti. Ailemin dengesini yeniden kurdu adeta.',
    rating: 5,
    service: 'Çocuk & Ergen Danışmanlığı',
  },
  {
    id: 5,
    name: 'Neslihan A.',
    initials: 'NA',
    comment: 'Boşanma sürecinde ne kadar yalnız hissettim bilmiyorsunuz. Ama Ayşegül Hanım o zor dönemde yanımda oldu. Hem profesyonel hem de çok insani bir destek aldım.',
    rating: 5,
    service: 'Boşanma ve Yas Süreci',
  },
];